/**
 * @file index.tsx
 *
 * @fileoverview Renders blog standalone image.
 */
import Image from '~/jobiqo/components/Image';
import { Image as ImageType } from '~/jobiqo/types/types';
import styles from './blogImage.module.scss';

interface BlogImageRowProps {
  /**
   * The image.
   */
  image: ImageType;
}

export default function BlogImageRow({
  image: { url, width, height, alt, title, caption },
}: BlogImageRowProps) {
  return (
    <div className={styles.blogImage}>
      <Image
        src={url}
        width={width}
        height={height}
        alt={alt ?? ''}
        {...(title && { title })}
        caption={caption as string}
      />
    </div>
  );
}

export { BlogImageRow };
